import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// hooks
import useLanguage from '../hooks/useLanguage';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

AdminGuard.propTypes = {
  children: PropTypes.node,
};

export default function AdminGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  const { getLocalizedPath } = useLanguage();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    // Redirect to login with language prefix
    return <Navigate to={getLocalizedPath('/auth/login')} />;
  }

  // Check if user has staff privileges
  // Check both is_staff_user (custom role system) and is_staff (Django default)
  if (!user?.is_staff_user && !user?.is_staff) {
    // Redirect to 403 page with language prefix
    return <Navigate to={getLocalizedPath('/403')} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
